<template>
  <smd-chat-status v-bind="chatStatusBindValues"
                   class="chat-item-doctor"
                   :class="{'smd-panel': !$isMobile}"
                   @click.native="onItemClick">
  </smd-chat-status>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {
    MSG_TYPES,
    MESSAGE_PROP_MSG_TYPE,
    DATE_PROP_MSG_TYPE,
  } from '@/constants/inbox-messages';
  import {
    messageDateFormatter,
  } from '@/utils/dates';
  import {
    CHAT_ROUTE,
    MESSAGE_DOCTOR_PARAM,
    MESSAGE_PATIENT_ID_PARAM,
  } from '@/router/routes';
  import GetElementStringMixin from '@/mixins/get-element-string';
  import {
    GETTER_DOCTOR_PATIENT_PARTNER,
    GETTER_DOCTOR_LATEST_MESSAGES,
    GETTER_UNREAD_MESSAGES,
  } from '@/store/types';

  export default {
    name: 'chat-item-doctor',
    mixins: [
      GetElementStringMixin,
    ],
    props: {
      message: {type: Object, default: null},
      pairToken: {type: String, required: true},
    },
    computed: {
      ...mapGetters({
        getDoctorPatientPair: GETTER_DOCTOR_PATIENT_PARTNER,
        doctorLatestMessages: GETTER_DOCTOR_LATEST_MESSAGES,
        unreadCountsList: GETTER_UNREAD_MESSAGES,
      }),
      doctor() {
        return this.getDoctorPatientPair[this.pairToken].doctor;
      },
      patient() {
        return this.getDoctorPatientPair[this.pairToken].patient;
      },
      localStorageKey() {
        return this.getDoctorPatientPair[this.pairToken].localStorageKey;
      },
      name() {
        return this.doctor._fullName;
      },
      nameDescription() {
        return this.patient.name;
      },
      previewMessage() {
        if (!this.message) {
          return this.getElementString('txt629');
        }

        if (this.message.msgtype === MSG_TYPES.pxbill) {
          return `${this.doctor._fullName} sent you a bill`;
        }

        if (this.message.attachments) {
          return 'Sent you an attachment';
        }

        if (this.message.msgtype === MSG_TYPES.educ ||
            this.message.msgtype === MSG_TYPES.file ||
            this.message.msgtype === MSG_TYPES.prescription) {
          return 'Sent you a file';
        }

        return this.doctorLatestMessages[this.localStorageKey][MESSAGE_PROP_MSG_TYPE[this.message.msgtype]];
      },
      dateString() {
        if (!this.message) return null;
        return messageDateFormatter(this.message[DATE_PROP_MSG_TYPE[this.message.msgtype]]);
      },
      image() {
        return this.doctor.profile_url;
      },
      chatStatusBindValues() {
        const bindValues = {
          name: this.name,
          nameDescription: this.nameDescription,
          message: this.previewMessage,
          dateString: this.dateString,
          image: this.image,
        };

        if (this.unreadCountsList[this.localStorageKey]) {
          bindValues.unread = !!this.unreadCountsList[this.localStorageKey];
          bindValues.notifs = this.unreadCountsList[this.localStorageKey];
        }

        return bindValues;
      },
    },
    methods: {
      onItemClick() {
        this.$router.push({
          name: CHAT_ROUTE,
          params: {
            [MESSAGE_DOCTOR_PARAM]: this.doctor.usertag,
            [MESSAGE_PATIENT_ID_PARAM]: this.patient.id,
          },
        });
      },
    },
  }
</script>
